<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Channel Video Claims</p>
          <div class="float-right">
        <span v-if="tabs === 'manual'">
              <el-tag type="success" style="margin-right: 15px">Last updated: {{ formattedLastUpdated }}</el-tag>
              <el-tooltip content="Sync with youtube studio" placement="top">
                <el-button
                    type="success"
                    circle
                    icon="el-icon-refresh"
                    @click.prevent="syncClaims()"
                    class="mr20"
                ></el-button>
              </el-tooltip>

            </span>
            <ManualFilters v-if="tabs === 'manual'"/>
          </div>
          <Filters v-if="tabs === 'auto'"/>
        </div>

        <el-tabs type="border-card"  v-model="tabs">
          <el-tab-pane label="Manual claimed videos requests" name="manual">
            <ManualClaims/>
          </el-tab-pane>
          <el-tab-pane label="Manual Video Claims" name="auto">
            <Table/>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/youtube/channel-video-claims/Table'
import Filters from '../components/youtube/channel-video-claims/Filters'
import ManualFilters from '../components/youtube/channel-video-claims/ManualFilters'
import { mapActions, mapState } from 'vuex'
import ClaimsRemovalRequests from "@/modules/admin/cms/components/youtube/claims/ClaimsRemovalRequests.vue";
import ManualClaims from "@/modules/admin/cms/components/youtube/channel-video-claims/ManualClaims.vue";

export default {
  components: {
    ManualClaims,
    ClaimsRemovalRequests,
    Table,
    Filters,
    ManualFilters
  },
  data() {
    return {
      tabs: 'manual',
    }
  },
  computed: {
    ...mapState('channelVideoClaims', ['loading','stats','last_updated']),
    formattedLastUpdated() {
      console.log('last_updated:', this.last_updated);
      return this.last_updated ? new Date(this.last_updated).toLocaleString() : 'N/A';
    }
  },

  methods: {
    ...mapActions('channelVideoClaims', ['readChannels','syncClaims'])
  },
  created() {
    this.readChannels()
  }
}
</script>
